<template>
  <div id="DocumentLimitTransactionCreditorInformation" class="sun not-full">
    <div class="title">
      채권자 정보
    </div>
    <table>
      <tr>
        <td>회사명</td>
        <td class="seal-box">
          <span>
            {{company.name}}
            <img src="@/assets/images/documents/funda_onto_seal.png" />
          </span>
        </td>
      </tr>
      <tr>
        <td>등록번호</td>
        <td v-html="company.lendingRegisterNumber"></td>
      </tr>
      <tr>
        <td>전화번호</td>
        <td>{{company.phoneNumber}}</td>
      </tr>
      <tr>
        <td>사업자등록번호</td>
        <td>{{company.businessNumber}}</td>
      </tr>
      <tr>
        <td>주소</td>
        <td v-html="company.address"></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionCreditorInformation',
  data: function () {
    return {
      company: {
        name: '(주)펀다',
        lendingRegisterNumber: '온라인투자연계금융업<br />2022-금융위원회-18',
        phoneNumber: '1811-2807',
        businessNumber: '724-87-00107',
        address: '서울 서초구 사평대로53길 30 메이크잇 203호 ,204호',
      },
    }
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionCreditorInformation {
    padding-top: 30px;
    padding-bottom: 11px;
    .title {
      font-weight: 900;
      font-size: 16px;
      line-height: 1.5;
      color: #333333;
    }

    .seal-box {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 80px;
        position: absolute;
        right: -70px;
        top: -24px;
      }
    }

    table {
      width: 100%;
      border-top: solid 1px #727d8c;
      border-collapse: collapse;
      margin-top: 11px;
      tr {
        border-bottom: solid 1px #d7e1ea;
        td {
          height: 48px;
        }
        td:first-child {
          width: calc(136% / 325 * 100);
          background-color: #f4faff;
          font-weight: 600;
          font-size: 15px;
          line-height: 2.13;
          text-align: center;
          color: #333333;

          @media screen and (max-width: 350px) {
            font-size: 13px;
          }
        }
        td:last-child {
          font-weight: 900;
          font-size: 16px;
          line-height: 2;
          text-align: center;
          color: #333333;

          @media screen and (max-width: 350px) {
            font-size: 14px;
          }
        }
      }
    }
  }
</style>
